// @ts-strict-ignore
import styled from "styled-components";

export const AuthorImage = styled.div`
  img {
    border-radius: 50%;
    object-fit: cover;
    width: 150px;
    height: 150px;
  }
  align-items: center;
  padding: 24px 24px 24px 0;
`;

export const AuthorSocial = styled.div`
  display: flex;
`;

export const SocialButtons = styled.div`
  display: flex;
  align-items: center;
  padding-left: 5px;
  img {
    padding: 0 5px;
    width: 20px;
    height: 20px;
  }
`;
